import FeatureFlagsLibsIntro from "../../../../contents/docs/libraries/_snippets/feature-flags-libs-intro.mdx";
import APIFeatureFlagsCode from "../../../../contents/docs/integrate/feature-flags-code/_snippets/feature-flags-code-api.mdx";
import * as React from 'react';
export default {
  FeatureFlagsLibsIntro,
  APIFeatureFlagsCode,
  React
};